import React from 'react';
import ReactDOM from 'react-dom/client';
import { installApiShim } from './apiShim';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme';
import reportWebVitals from './reportWebVitals';

// Before anything renders: every API call carries the session cookie and,
// for a write, the CSRF header (apiShim.js).
installApiShim();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
